var map = {
	"./agentSoundEffect.m4a": 2832,
	"./agentSoundEffect.mp3": 2833,
	"./agentSoundEffect.ogg": 2834,
	"./agentSoundEffect.wav": 2835,
	"./kpSoundEffect.m4a": 2836,
	"./kpSoundEffect.mp3": 2837,
	"./kpSoundEffect.ogg": 2838,
	"./kpSoundEffect.wav": 2839,
	"./systemSoundEffect.m4a": 2840,
	"./systemSoundEffect.mp3": 2841,
	"./systemSoundEffect.ogg": 2842,
	"./systemSoundEffect.wav": 2843
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2831;